
import { MDBox } from "../MDBox";

interface IDataTableHeadCellProps {
  children: React.ReactNode;
  sorted?: false | "none"| "asce" | "desc";
  align?: "left" | "right" | "center";
  width?: string | number,
  [rest: string]: any;
}

export function BasicDataTableHeadCell({ 
  width = "auto", 
  children, sorted = "none", 
  align = "left", 
  ...rest 
} : IDataTableHeadCellProps) {


  return (
    <MDBox
      component="th"
      width={width}
      py={1.5}
      px={3}
      sx={({ palette: { light }, borders: { borderWidth } } : any) => ({
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
        paddingLeft: "12px"

      })}
    >
        <MDBox
          {...rest}
          position="relative"
          textAlign={align}
          color={"white"}
          sx={({ typography: { size, fontWeightBold } }: any) => ({
            fontSize: size.xxs,
            fontWeight: fontWeightBold,
            textTransform: "uppercase",
            cursor: sorted && "pointer",
            userSelect: sorted && "none",
            display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'
          })}
        >
        {children}
          </MDBox>
    </MDBox>
  );
}
